  /* eslint-disable */
import React, {useState, useRef, useEffect} from 'react'
const Icon = styled.img``;
import Svg from "_assets/svg";
import Search from 'components/SearchV2';
import _ from 'lodash';
import FeatherIcon from 'feather-icons-react';
// library
import styled from 'styled-components';

// style
import './DropdownV4.scss'

function DropdownButtonTemplate(props) {
  const {isListSearch, setSelectedSearch, isSelected, placeholder, className, buttonData} = props;

  const [isShowListSearch, setShowListSearch] = useState(false)
  const [isLoopingList, setLoopingList] = useState({})
  const [isDataDropdown, setDataDropdown] = useState([])

  const container = useRef();

  useEffect(()=>{
    setLoopingList(isSelected)
   
  },[isSelected])
  
  useEffect(()=>{
    setDataDropdown(isListSearch)
  }, [isListSearch])

  const dataVisitWeb = [];
  const dataPhoneNumber = [];
  const dataPromoCode = [];
  const dataMarketing = [];
  if(buttonData){
    buttonData.forEach((item) => {
      if(item.buttonType === 'CTA'){
        item.buttons.forEach((result) => {
      
          if(result?.typeCTA?.value === "visit_web"){
            dataVisitWeb.push(result);
          }
          if(result?.typeCTA?.value === "call_phone_number"){
            dataPhoneNumber.push(result);
          }
          if(result?.typeCTA?.value === "copy_promo_code"){
            dataPromoCode.push(result);
          }
          if(result?.typeCTA?.value === "marketing_disapproval"){
            dataMarketing.push(result);
          }
        })
      }
      if(item.buttonType === 'QUICK_REPLY'){
        item.buttons.forEach((result) => {
          console.log('items data', result)
          if(result?.typeCTA?.value === "marketing_disapproval"){
            dataMarketing.push(result);
          }
        })
      }
      
    })
  }

  function chooseSearchType(item){
    setLoopingList(item)
    setSelectedSearch(item)
    setShowListSearch(false)
  }

  function handleClickSearch(){
    setShowListSearch(!isShowListSearch)
  }

  useEffect(() => {
    function handleClickOutside(event) {
        if (container.current && !container.current.contains(event.target)) {
          setShowListSearch(false);
        }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [container])

  return (
    <div className={`${className} dropdown_v4`} ref={container}>
      <div onClick={handleClickSearch} className='selected form-control'>
        <span className={`cl-white fsize-14 fweight-600 mb-0 capitalize`}>Add buttons</span>
        <FeatherIcon icon="chevron-down" className={`ms-2 cl-white ${isShowListSearch ? 'rotate_180' : 'rotate_0'}`} width="17" />
      </div>
      {isShowListSearch &&
      <div className='dropdown p-0'>
        <div className='list_search'>
          {isDataDropdown.map((item, idx) =>{
            console.log('values', item, isSelected, isLoopingList)
            return <div key={idx}>
                {item.value === "quick_reply" && (
                  <div className='mb-3'>
                    <div className='d-flex align-items-center mb-2'>
                      <FeatherIcon icon="corner-up-left" className={`me-2 feather_button_template`} width="16" />
                      <p className={`m-0 fsize-14 fweight-600 mb-0`} >{item.title}</p>
                    </div>
                    {item.menus.map((menu, index) => {
                      return <div 
                      key={index} 
                      onClick={()=>chooseSearchType(menu)} 
                      className={
                        `${menu.disable ? 'event_disable' : ''} 
                        ${menu.value === 'marketing_disapproval' && dataMarketing.length === 1 ? 'event_disable' : ''} 
                        hover d-flex flex-column mb-1`}>
                        <p className={`cl-neutral400 fsize-14 fweight-400 mb-1`}>{menu.name}</p>
                        {menu.description && (
                          <span className={`cl-neutral text-italic fsize-12 fst-italic fweight-400 mb-0`}>{menu.description}</span>
                        )}
                      </div>
                    })}
                  </div>
                )}
                {item.value === "call_to_action" && (
                  <div>
                    <div className='d-flex align-items-center mb-2'>
                      <FeatherIcon icon="external-link" className={`me-2 feather_button_template`} width="16" />
                      <p className={`m-0 fsize-14 fweight-600 mb-0`} >{item.title}</p>
                    </div>
                    {item.menus.map((menu, index) => {
                      return <div 
                      key={index} 
                      onClick={()=>chooseSearchType(menu)} 
                      className={`
                        ${menu.value === 'visit_web' && dataVisitWeb.length === 2 || menu.value === 'visit_web' && menu.description == 'max 1 button' ? 'event_disable' : ''} 
                        ${menu.value === 'call_phone_number' && dataPhoneNumber.length === 1 ? 'event_disable' : ''} 
                        ${menu.value === 'copy_promo_code' && dataPromoCode.length === 1 ? 'event_disable' : ''} 
                        hover d-flex flex-column mb-1
                        `}>
                        <p className={`cl-neutral400 fsize-14 fweight-400 mb-1`}>{menu.name}</p>
                        {menu.description && (
                          <span className={`cl-neutral text-italic fsize-12 fst-italic fweight-400 mb-0`}>{menu.description}</span>
                        )}
                      </div>
                    })}
                  </div>
                )}
              </div>

          })}
          {/* <div>
            {isDataDropdownCTA.map((item, idx) =>{
              console.log('values', item, isSelected, isLoopingList)
              return <span className={`${item.disable ? 'event_disable' : ''} cl-white fsize-14 fweight-400 mb-0 px-3`} onClick={()=>chooseSearchType(item)} key={idx}>{item.name}</span>
            })}
          </div> */}
        </div>
      </div>
      }
    </div>
  )
}

export default DropdownButtonTemplate